<template>
	<div class="page-wrapper landing-background ">
			<div class="logo-box locate-center">
				<div class="logo-container">
					<img class="logo logo-show-mobile" src="https://borium.s3.eu-west-2.amazonaws.com/sushinara/logo-sushinara.png"/>
					
				</div>

				<div class="container section-container">
					<div class="row">
						<div class="col-12">
							<h4>Select Location</h4>
						</div>
					</div>
				</div>

				<div class="container section-container">
					<div class="row">
						<div class="col-6">
							<div class="location-btn" v-on:click="moveToHome('Guildford')">Guildford</div>
						</div>
						<div class="col-6">
							<div class="location-btn" v-on:click="moveToHome('Staines')">Staines</div>
						</div>
					</div>
				</div>
			</div>
			
	</div>
</template>
<script>
require('@/assets/css/styles.css')

import axios from 'axios';

export default {
	name: 'Welcome',
	data () {
		return {
		}
	},
	methods: {
		moveToHome: function(branch) {
			this.$router.push({path: '/home', query : { branch: branch}});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Landing.vue